module.exports = __webpack_public_path__ + "static/media/Raum_19_Coaching.2509de86.jpg";